exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fieldset {\n  padding: 12px;\n  margin: 8px 0px 16px 0px;\n  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.5);\n}\n.fieldset>.legend {\n  font-size: 1.2em;\n  margin: 0px 0px 12px 0px;\n  border-bottom: 1px solid rgba(0,0,0,0.5);\n}\n\n.bg-dark {\n  background-color: #000!important;\n}\n\n.row.top {\n\n}\n\n.row.pagination {\n  background-color: #6FB5FE; padding: 12px;\n}\n.row.pagination > .col.pagination-controls .input-group {\n  margin: 0px auto;\n}\n.row.pagination > .col.items-per-page {\n  text-align: right;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/.NET Projects/Angular Apps/TimeManagement/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!C:/.NET Projects/Angular Apps/TimeManagement/node_modules/postcss-loader?{"ident":"postcss"}!C:/.NET Projects/Angular Apps/TimeManagement/src/css/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/css/styles.css
// module chunks = styles